import React from 'react';
import './ScrollingBanner.css';

interface ScrollingBannerProps {
  message: string;
}

const ScrollingBanner: React.FC<ScrollingBannerProps> = ({ message }) => {
  return (
    <div className="scrolling-banner-container">
      <div className="scrolling-banner">
        <span>{message}</span>
      </div>
    </div>
  );
};

export default ScrollingBanner; 